import { useState, useEffect, useCallback } from 'react';

const twoDigits = (num: number) => String(num).padStart(2, '0');

export const useCountdown = (initial: number) => {
  const [secondsRemaining, setSecondsRemaining] = useState(initial);
  const secondsToDisplay = secondsRemaining % 60;
  const minutesToDisplay = ((secondsRemaining - secondsToDisplay) / 60) % 60;

  const reset = useCallback(() => setSecondsRemaining(initial), [initial]);

  useEffect(() => {
    if (secondsRemaining > 0) {
      const interval = setInterval(() => {
        setSecondsRemaining(secondsRemaining - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [secondsRemaining]);

  return {
    secondsRemaining,
    secondsToDisplay: twoDigits(secondsToDisplay),
    minutesToDisplay: twoDigits(minutesToDisplay),
    reset,
  };
};
